export enum RechargerType {
    PHYSICAL = 1,
    VIRTUAL = 2
}